import { fetchAdministrationHealth } from "../../api/administrationOperations";
import { createResourceLoader } from "./keyedResourceLoader";
import type { AdministrationSlice, HealthSlice } from "./types";

const loader = createResourceLoader();
export const healthInitialState = {
  health: null,
  healthFetchedAt: null,
  healthHydrated: false,
  healthLoading: false,
  healthError: "",
};
export const resetHealthRequests = loader.clear;
export const createHealthSlice: AdministrationSlice<HealthSlice> = (set, get) => ({
  ...healthInitialState,
  loadHealth: (force = false) => loader.load({
    force,
    cached: get().healthHydrated,
    request: fetchAdministrationHealth,
    onStart: () => set({ healthLoading: true, healthError: "" }),
    onSuccess: (health) => set({ health, healthFetchedAt: Date.now(), healthHydrated: true }),
    onError: (healthError) => set({ healthError }),
    onFinish: () => set({ healthLoading: false }),
    errorMessage: "Unable to load backend health.",
  }),
});
